import React, { memo, useMemo } from "react";
import { theme } from "uikit";
import { useTranslation } from "react-i18next";

import Map, { type PolygonList } from "../../../../DispatcherMap";
import { useTypedSelector } from "../../../../../redux/store";

const PriceZonesBase: React.FC<PriceZonesBase.Props> = ({
	taxiServiceIds,
	taxiServiceId,
}): JSX.Element => {
	const { t } = useTranslation();

	const language = useTypedSelector((state) => state.session.language);

	const items = useTypedSelector(
		(state) => state.globalState.priceZones.data.subscription.basic,
	);

	const text = useMemo(
		() => t(`mainPage.archives.orders.modal.map.polygons.priceZone`),
		[t],
	);
	const value = useMemo<PolygonList | undefined>(() => {
		if (Array.isArray(taxiServiceIds)) {
			return items
				?.filter((item) => taxiServiceIds.includes(item?.taxiServiceId))
				?.map((priceZone) => ({
					id: priceZone.id,
					name:
						`${text} ${priceZone.name?.[language]}` ||
						Object.values(priceZone.name)?.[0],
					color: theme.colors.success,
					vertices: priceZone.vertices.map((v) => [v.lat, v.lng]),
					editable: false,
				}));
		}

		if (taxiServiceId) {
			return items
				?.filter((item) => item?.taxiServiceId === taxiServiceId)
				?.map((priceZone) => ({
					id: priceZone.id,
					name:
						`${text} ${priceZone.name?.[language]}` ||
						Object.values(priceZone.name)?.[0],
					color: theme.colors.success,
					vertices: priceZone.vertices.map((v) => [v.lat, v.lng]),
					editable: false,
				}));
		}

		return items?.map((priceZone) => ({
			id: priceZone.id,
			name:
				`${text} ${priceZone.name?.[language]}` ||
				Object.values(priceZone.name)?.[0],
			color: theme.colors.success,
			vertices: priceZone.vertices.map((v) => [v.lat, v.lng]),
			editable: false,
		}));
	}, [taxiServiceIds, taxiServiceId, items, text, language]);

	return <Map.PolygonEditor value={value} editing={false} />;
};

declare namespace PriceZonesBase {
	interface Props {
		taxiServiceId?: number;
		taxiServiceIds?: number[];
	}
}

const PriceZones = memo(PriceZonesBase);

export default PriceZones;
